import { Box } from 'ui/box';
import { Stack } from 'ui/stack';

import Icons from 'assets/icons';

interface AuthorProps {
  avatar?: string;
  name?: string;
  position?: string;
}

const Author = ({ avatar, name, position }: AuthorProps): React.JSX.Element => (
  <Stack
    direction="row"
    sx={{
      alignItems: 'center',
      bgcolor: 'tokens.navy.50',
      py: 1.25,
      px: 2,
      borderRadius: '0.375rem',
    }}
  >
    {avatar ? (
      <img
        src={avatar}
        alt={name}
        className="flex h-10 w-10 justify-center rounded-[50%] mr-1"
      />
    ) : (
      <Icons.Profile
        className="w-10 h-10 text-navy-200 mr-1"
        aria-hidden="true"
      />
    )}
    <Box>
      <Box sx={{ color: 'tokens.gray.950', fontWeight: 600 }}>{name}</Box>
      <Box
        sx={{
          color: 'tokens.gray.700',
          fontSize: '0.875rem',
          lineHeight: '1.25rem',
        }}
      >
        {position}
      </Box>
    </Box>
  </Stack>
);

export default Author;
